import {Injectable} from '@angular/core';
import {MessageService} from 'primeng/api';

@Injectable({providedIn: 'root'})
export class ToastService {
  constructor(
    private readonly messageService: MessageService
  ) {
  }

  success(message: string, lifetime?: number) {
    this.show('success', 'Ok', message, lifetime);
  }

  warning(message: string, lifetime?: number) {
    this.show('warn', 'Waarschuwing', message, lifetime);
  }

  error(message: string, lifetime?: number) {
    this.show('error', 'Fout', message, lifetime);
  }

  info(message: string, lifetime?: number) {
    this.show('info', 'Informatie', message, lifetime);
  }

  private show(severity: 'success' | 'warn' | 'error' | 'info', title: string, message: string, lifetime = 4000) {
    this.messageService.add({severity, summary: title, detail: message, life: lifetime});
  }
}
